import { render, staticRenderFns } from "./inputbankstatement.vue?vue&type=template&id=ac7156aa&"
import script from "./inputbankstatement.vue?vue&type=script&lang=js&"
export * from "./inputbankstatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports